import { useMemo } from 'react';
import type { FieldPath, FieldValues } from 'react-hook-form';
import RhfSelect, {
  type RhfSelectProps,
} from '@core/components/forms/fields/RhfSelect';
import type { Vestment } from '../../../api/vestment';
import { useAppContext } from '../../context/AppContext';
import { type CollarOption, getCollarOptions } from '../../utils/collar';

type RhfCollarSelectProps<T extends FieldValues> = {
  name: FieldPath<T>;
  label: string;
  vestment?: Vestment;
} & Omit<
  RhfSelectProps<T, CollarOption>,
  'name' | 'label' | 'items' | 'getOptionValue' | 'getOptionLabel' | 'options'
>;

export function RhfCollarSelect<T extends FieldValues>({
  name,
  label,
  vestment,
  ...rest
}: RhfCollarSelectProps<T>) {
  const { collars } = useAppContext();
  const items = useMemo(
    () => getCollarOptions(vestment, collars),
    [collars, vestment]
  );

  return (
    <RhfSelect<T, CollarOption>
      name={name}
      label={label}
      items={items}
      getOptionValue={(collar) => String(collar.id)}
      getOptionLabel={(collar) => collar.name}
      {...rest}
    />
  );
}
